import React, { useContext, useEffect } from 'react';
import parse from 'html-react-parser';
import './ResourceHtml.css';

const ResourseHtml = ({ data }) => {
    console.log(data.content);
    return <div className='resource__html'>{parse(data.content)}</div>;
};
export default ResourseHtml;
